/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ChildIndividual } from './ChildIndividual';
import type { ChoiceAnswerModel } from './ChoiceAnswerModel';
export type IndividualQuestionBaseRepresentation = {
  readonly id?: number;
  name: string;
  question_type: IndividualQuestionBaseRepresentation.question_type;
  options: Array<ChoiceAnswerModel>;
  description?: string | null;
  readonly children_questions?: Array<ChildIndividual>;
};
export namespace IndividualQuestionBaseRepresentation {
  export enum question_type {
    TEXT = 'text',
    DATE = 'date',
    DROPDOWN = 'dropdown',
    MULTIPLE = 'multiple',
  }
}
